module.exports = __webpack_public_path__ + "static/media/logo-technasium.4100434d.svg";